<svg
  width="24"
  height="25"
  viewBox="0 0 24 25"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M19.875 4.09375H4.125C3.71079 4.09375 3.375 4.42954 3.375 4.84375V20.5938C3.375 21.008 3.71079 21.3438 4.125 21.3438H19.875C20.2892 21.3438 20.625 21.008 20.625 20.5938V4.84375C20.625 4.42954 20.2892 4.09375 19.875 4.09375Z"
    stroke="currentColor"
    stroke-width="1.4"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <path
    d="M11.25 11.2188V17.2188"
    stroke="currentColor"
    stroke-width="1.4"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <path
    d="M8.25 11.2188V17.2188"
    stroke="currentColor"
    stroke-width="1.4"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <path
    d="M11.25 13.8438C11.25 13.1476 11.5266 12.4799 12.0188 11.9876C12.5111 11.4953 13.1788 11.2188 13.875 11.2188C14.5712 11.2188 15.2389 11.4953 15.7312 11.9876C16.2234 12.4799 16.5 13.1476 16.5 13.8438V17.2188"
    stroke="currentColor"
    stroke-width="1.4"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <path
    d="M8.25 9.34375C8.87132 9.34375 9.375 8.84007 9.375 8.21875C9.375 7.59743 8.87132 7.09375 8.25 7.09375C7.62868 7.09375 7.125 7.59743 7.125 8.21875C7.125 8.84007 7.62868 9.34375 8.25 9.34375Z"
    fill="currentColor"
  />
</svg>
